import { useEffect } from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18n-lite'

import { interactionModelOperations } from '../redux'
import { useAuthentication } from 'authentication'
import { useAppDispatch } from 'state/store'
import { InteractionModel } from 'types/shared'

const useInitialConfig = (interactionModel: InteractionModel) => {
  const dispatch = useAppDispatch()

  const { userName, userUuid } = useAuthentication()

  const { language: lang } = useTranslation()

  const {
    userUuid: oldUserUuid,
    dateStartInteraction,
    language
  } = interactionModel

  useEffect(() => {
    if (userUuid && userName && oldUserUuid !== userUuid) {
      dispatch(
        interactionModelOperations.setInitialConfiguration(
          userUuid,
          userName,
          moment().format(),
          lang
        )
      )
    }
  }, [
    dispatch,
    interactionModel,
    userUuid,
    userName,
    oldUserUuid,
    lang,
    dateStartInteraction,
    language
  ])

  return null
}

export default useInitialConfig
